import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import { lazy } from "react";

const AboutPage = lazy(() => import("../pages/about/page"));
const ProductsPage = lazy(() => import("../pages/products/page"));
const TechnologyPage = lazy(() => import("../pages/technology/page"));
const FeaturesPage = lazy(() => import("../pages/features/page"));
const ContactPage = lazy(() => import("../pages/contact/page"));
const TestResultsPage = lazy(() => import("../pages/test-results/page"));
const CaseStudiesPage = lazy(() => import("../pages/case-studies/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/products",
    element: <ProductsPage />,
  },
  {
    path: "/technology",
    element: <TechnologyPage />,
  },
  {
    path: "/features",
    element: <FeaturesPage />,
  },
  {
    path: "/test-results/:category",
    element: <TestResultsPage />,
  },
  {
    path: "/case-studies",
    element: <CaseStudiesPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
